export const OVERVIEW = 'overview';
export const ADD = 'add';
export const EDIT = 'edit';
export const LINK = 'link';
export const PLAID = 'plaid';
